var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"section-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }